import { flattenNestedSvg } from '@/utils'

import { FrameText } from './FrameText'
import { MockQr } from './MockQr'
import {
	DEFAULT_FRAME_FONT,
	FRAME_BLACK,
	FRAME_LIGHT_GREY,
} from './qrFramesConstants'
import { isNormalFrameMode, TQrFrameProps } from './qrFrameTypes'

export const Frame30 = (props: TQrFrameProps) => {
	const qrMarkup = isNormalFrameMode(props) ? props.patternMarkup : undefined
	const frameColor = isNormalFrameMode(props) ? props.frameColor : FRAME_BLACK
	const textColor = isNormalFrameMode(props) ? props.textColor : FRAME_BLACK
	const qrBackgroundColor = isNormalFrameMode(props)
		? props.patternBackgroundColor
		: FRAME_LIGHT_GREY
	const frameBackgroundColor = isNormalFrameMode(props)
		? props.frameBackgroundColor
		: 'white'

	const getTextY = (fontSize: number) => {
		const boxTop = 70
		const boxHeight = 10
		const centerY = boxTop + boxHeight / 2
		return centerY + fontSize * 0.085
	}

	return (
		<svg viewBox="0 0 64 84" fill="none" xmlns="http://www.w3.org/2000/svg">
			<path
				id="frame-background"
				fillRule="evenodd"
				clipRule="evenodd"
				d="M8.5 21v37l3.5 4.5h35l2.5-2.5 1-6.5V48l5.5-2 2.5-2.5 1.5-4-.5-4L58 32l-3.5-2.5-3-1h-1V21zm42 12.2V43h1l1.5-.5 2-3 .5-1.5-1-2.5-2-1.5z"
				fill={frameBackgroundColor}
			/>
			<g id="frame" fill={frameColor}>
				<path d="M20.413 17.074c.168.113.356.17.543.17.282 0 .582-.15.75-.358.15-.206 1.425-2.029 1.425-3.57s-.45-2.349-.806-2.988c-.262-.488-.431-.808-.431-1.428 0-1.292.787-2.019.89-2.114l.01-.009-1.181-1.485c-.057.038-1.594 1.297-1.594 3.59 0 1.115.349 1.752.665 2.33l.01.018.006.011c.297.54.556 1.011.556 2.056 0 .714-.656 1.88-1.069 2.462-.3.413-.187 1.015.226 1.315" />
				<path
					fillRule="evenodd"
					clipRule="evenodd"
					d="M50.6 43.832h-.937V32.69h.937c3.056 0 5.55 2.5 5.55 5.563s-2.494 5.58-5.55 5.58m.956-9.113v7.103a3.674 3.674 0 0 0 2.719-3.552 3.674 3.674 0 0 0-2.719-3.551"
				/>
				<path
					fillRule="evenodd"
					clipRule="evenodd"
					d="M49.145 61.684a8.88 8.88 0 0 0 2.411-6.089v-7.027c5.25-.489 9.375-4.905 9.375-10.298s-4.125-9.809-9.375-10.297v-6.708c0-.865-.694-1.56-1.556-1.56H8.975c-.862 0-1.556.695-1.556 1.56v34.33a8.9 8.9 0 0 0 2.404 6.089h-5.76a.86.86 0 0 0-.863.864v.17a.86.86 0 0 0 .863.863h.188a5.79 5.79 0 0 0 5.793 5.694H48.93a5.79 5.79 0 0 0 5.793-5.694h.189a.86.86 0 0 0 .862-.864v-.169a.86.86 0 0 0-.862-.864zm-3.035 0a7.02 7.02 0 0 0 3.534-6.089v-8.888h.937c4.65 0 8.419-3.777 8.419-8.437s-3.769-8.437-8.419-8.437h-.937v-8.23H9.313v33.992a7.02 7.02 0 0 0 3.534 6.089z"
				/>
				<path d="M28.869 17.243a1 1 0 0 1-.544-.169c-.412-.3-.525-.902-.225-1.315.412-.583 1.069-1.748 1.069-2.462 0-1.045-.26-1.516-.557-2.056l-.006-.01-.01-.02c-.316-.577-.665-1.214-.665-2.33 0-2.292 1.538-3.55 1.594-3.589l1.163 1.466-.01.01c-.103.095-.89.821-.89 2.114 0 .62.168.94.45 1.428.356.638.806 1.447.806 2.987s-1.275 3.364-1.425 3.57a.98.98 0 0 1-.75.376m7.369-.169c.168.113.356.17.543.17.282 0 .581-.15.75-.358.15-.206 1.425-2.029 1.425-3.57s-.45-2.349-.806-2.988c-.262-.488-.431-.808-.431-1.428 0-1.292.787-2.019.89-2.114l.01-.009-1.181-1.485c-.057.038-1.594 1.297-1.594 3.59 0 1.115.349 1.752.665 2.33l.01.018.006.011c.297.54.556 1.011.556 2.056 0 .714-.656 1.88-1.069 2.462-.3.413-.187 1.015.225 1.315" />
			</g>
			<rect
				id="qr-background"
				x={13}
				y={24.5}
				width={33}
				height={33}
				rx={2}
				fill={qrBackgroundColor}
			/>
			{qrMarkup ? (
				<g
					dangerouslySetInnerHTML={{
						__html: flattenNestedSvg(qrMarkup, {
							x: 18,
							y: 29.5,
							width: 23,
							height: 23,
						}),
					}}
				/>
			) : (
				<MockQr x={18} y={29.5} width={23} height={23} />
			)}
			<FrameText
				text={props.text}
				fontSize={props.fontSize}
				textColor={textColor}
				textY={getTextY(props.fontSize)}
				xOffset={-2}
				fontFamily={DEFAULT_FRAME_FONT}
			/>
		</svg>
	)
}
